import { Styles, generateClasses } from 'netline-ui';

export const noConnectionClasses = generateClasses('NoConnection', ['root', 'message'] as const);

const styles: Styles = ({ theme: { palette, spacing } }) => ({
  [`&.${noConnectionClasses.root}`]: {
    flexShrink: 0,
    backgroundColor: palette.error.main,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    padding: spacing(0.25, 1),
    fontSize: 12,
    lineHeight: '14px',
  },
  [`.${noConnectionClasses.message}`]: {
    paddingLeft: spacing(1),
  },
});

export default styles;
